import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ElMessage } from "element-plus";
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import order from "@/api/order";

export default /*#__PURE__*/_defineComponent({
  __name: 'Countdown',
  props: {
  rid: String,
},
  setup(__props) {

const props = __props;

const countdownTitle = ref<string>("");
const $store = useStore();
const getData = async () => {
  const getOrder = await order.getOrder(Number(props.rid));
  console.log (getOrder,595959)
  if (getOrder.status == 13) {
    $store.commit("talk/updateServiceExpireTime", { id: props.rid, time: 11 });
    countdownTitle.value = "服务已结束";
    return;
  }
  if (getOrder.customerService && getOrder.status == 6) {
    countdownTitle.value = "正在服务中";
    return;
  }
  if (getOrder.status == 13) {
    $store.commit("talk/updateServiceExpireTime", { id: props.rid, time: 11 });
    countdownTitle.value = "服务已结束";
    return;
  }
  console.log ($store.state.talk.serviceExpireTime[props.rid],7788899)
  if (!$store.state.talk.serviceExpireTime[props.rid]) {
    countdownTitle.value = "服务尚未开启";
    return;
  }
  if (Number($store.state.talk.serviceExpireTime[props.rid]) == 11) {
    countdownTitle.value = "服务已结束";
    return;
  }
  let timer;
  timer = setInterval(() => {
    let times =
      (Number($store.state.talk.serviceExpireTime[props.rid]) -
        Number(new Date())) /
      1000;
    if (times > 0) {
      //转换为天
      let d: number = Math.floor(times / 60 / 60 / 24);
      //转换为时
      let h: number = Math.floor((times / 60 / 60) % 24);
      //转换为分
      let m: number = Math.floor((times / 60) % 60);
      //转换成秒
      let s: number = Math.floor(times % 60);
      countdownTitle.value = `服务倒计时:${d}天${h}小时${m}分${s}秒`;
    } else {
      clearInterval(timer);
      if (Number($store.state.talk.serviceExpireTime[props.rid]) == 11) {
        countdownTitle.value = "服务已结束";
        return;
      }
      countdownTitle.value = "服务已超时";
      ElMessage.warning("服务已超时");
    }
  }, 1000);
};

watch(props, () => getData());
watch($store.state.talk.serviceExpireTime, () => getData());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(countdownTitle.value), 1))
}
}

})